import axios from "axios";
import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import ImgPlaceHolder from "../../constant/imgPlaceholder";
import { departmentAction } from "../../redux/action";
import { API_BASE_URL } from "../../redux/common/url";
import { ROUTE } from "../../route/Route";
import BreadCrumb from "../breadcrumb/BreadCrumb";
import SeoAdd from "../Seo/SeoAdd";
import SubmitForm from "../SubmitForm/SubmitForm";
import { useTranslation } from "react-i18next";
import { DoctorEnquiryform } from "../../constant/validation";
import SectionLoader from "../LodingScreen/SectionLoader";
import { groupBy } from "../../constant/utils";

function Brochure() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [brochure, setBrochure] = useState<any>({});
  const bData = useSelector((state: any) =>
    state.department.brochures ? state.department.brochures : {}
  );
  const brochureData = useSelector((state: any) =>
    state.department.brochures ? state.department.brochures?.List : {}
  );
  useEffect(() => {
    window?.scrollTo(0, 0);
    dispatch(departmentAction.brochuresListAction({}));
    return () => {};
  }, []);

  useEffect(() => {
    if (brochureData) {
      let newData = groupBy(brochureData, "department_id");
      // console.log(newData);
      setBrochure(newData);
    }
    return () => {};
  }, [brochureData]);
  /* const downLoadBrochure =(e:any,image:any) => {
        e.preventDefault();
        if(Baseurl && image && image !== null){
            const url = `${Baseurl}${image}`;
            console.log(url,window?.location?.origin?.toString());
            fetch(url,{
                headers: new Headers({
                  'Origin': window?.location?.origin?.toString()
                }),
                mode: 'cors'
              }).then((response:any) => {
                response?.data.blob().then((blob:any) => {
                    let url = window.URL.createObjectURL(blob);
                    let a = document.createElement("a");
                    a.href = url;
                    a.download = image;
                    a.click();
                    a.remove();
                });
            }).catch((error:any) => {
                console.log(error);
            })
        }
    } */

  return (
    <>
      <SeoAdd slug={ROUTE.BROCHURES} />
      <BreadCrumb page={t("brochures")} data={{ slug: "", path: "" }} />
      <section className="section brochures_page">
        <div className="container">
          <div className="row overview-top">
            <div className="col-md-12">
              <div className="overview-wrap text-center">
                {/* <img src="/assets/img/Department.png" className="scale" alt=""/> */}
                <div className="headingmains text-center pb-3">
                  <h1 className="right aos-init pb-2">{t("brochures")}</h1>
                </div>
                <p className="text-center">{t("brochures_desc")}</p>
              </div>
            </div>
          </div>
        </div>
        <section className="sub-section bg-grey home-services">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="headingmains text-center pb-3">
                  <h4 className="right pb-2">{t("all_brochures")}</h4>
                </div>
              </div>
            </div>
            <div className="tab-content mb-5 mb-lg-0">
              <div id="organs" className="tab-pane fade in active show">
                {bData && Object.keys(bData).length > 0 ? (
                  <>
                    {brochure && (
                      <>
                        {Object.values(brochure).length > 0 ? (
                          Object.values(brochure)?.map(
                            (items: any, index: any) => (
                              <>
                                <div className="row" key={"deprt" + index}>
                                  <div className="col-12">
                                    <div className="headingmains text-center pt-3">
                                      <h4 className="right pb-3">
                                        {items[0].department_name}
                                      </h4>
                                    </div>
                                  </div>
                                </div>
                                <div className="equal_clm h-services for-block-info">
                                  {items?.map((item: any, index: any) => (
                                    <div
                                      className="infobox_wrapper brochures_card"
                                      key={index}
                                    >
                                      <div>
                                        <div>
                                          <div className="infobox_icon_container pdf_icon">
                                            <img
                                              src="/assets/img/pdf_icon.png"
                                              className="scale"
                                              alt=""
                                            />
                                          </div>
                                          <h3 className="infobox_title text-capitalize">
                                            {item?.title}
                                          </h3>
                                          {item?.image ? (
                                            <a
                                              href={item?.image}
                                              className="book--hexagon active"
                                              target="_blank"
                                            >
                                              <span>
                                                <img
                                                  className="scale_download mr-2"
                                                  src="/assets/img/download_logo.png"
                                                  aria-hidden="true"
                                                />
                                                Download
                                              </span>
                                            </a>
                                          ) : (
                                            <a
                                              href=""
                                              className="book--hexagon active disable-download"
                                              onClick={(e: any) =>
                                                e.preventDefault()
                                              }
                                            >
                                              <span>
                                                <img
                                                  className="scale_download mr-2"
                                                  src="/assets/img/download_logo.png"
                                                  aria-hidden="true"
                                                />
                                                Download
                                              </span>
                                            </a>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </>
                            )
                          )
                        ) : (
                          <div className="singl_clm text-center f-16">
                            {t("no_data_available")}
                          </div>
                        )}
                      </>
                    )}
                  </>
                ) : (
                  <SectionLoader />
                )}
              </div>
            </div>
          </div>
        </section>
        <SubmitForm
          heading={t("reach_out-to_us")}
          des={""}
          PageSrc={"Brochures"}
          validationSchema={DoctorEnquiryform}
        />
      </section>
    </>
  );
}

export default Brochure;
